import React, { useCallback, useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import { MobileAppContext } from './MobileAppContext'

const STORAGE_KEY = 'hasMobileAppAccess'

export const MobileAppProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const location = useLocation()
  const [hasMobileAppAccess, setHasMobileAppAccess] = useState<
    boolean | undefined
  >(undefined)

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const ref = params.get('ref')
    const isSourceFromMobileApp = ref === 'mobile_app'

    if (isSourceFromMobileApp) {
      sessionStorage.setItem(STORAGE_KEY, 'true')
      setHasMobileAppAccess(true)
    } else {
      const stored = sessionStorage.getItem(STORAGE_KEY)
      setHasMobileAppAccess(stored === 'true')
    }
  }, [location.search])

  const clearMobileAppAccess = useCallback(() => {
    sessionStorage.removeItem(STORAGE_KEY)
    setHasMobileAppAccess(false)
  }, [])

  return (
    <MobileAppContext.Provider
      value={{ hasMobileAppAccess, clearMobileAppAccess }}
    >
      {children}
    </MobileAppContext.Provider>
  )
}
